import React, { Component } from "react";
import Lightbox from "react-image-lightbox";
import "react-image-lightbox/style.css";

import tabImg1 from "../assets/images/gallery/6.jpg";
import tabImg2 from "../assets/images/gallery/3.jpg";
import tabImg3 from "../assets/images/gallery/8.jpg";
import tabImg4 from "../assets/images/gallery/4.jpg";
import tabImg5 from "../assets/images/gallery/7.jpg";
import tabImg6 from "../assets/images/gallery/1.jpg";

import tabBgImg1 from "../assets/images/gallery/6.jpg";
import tabBgImg2 from "../assets/images/gallery/3.jpg";
import tabBgImg3 from "../assets/images/gallery/8.jpg";
import tabBgImg4 from "../assets/images/gallery/4.jpg";
import tabBgImg5 from "../assets/images/gallery/7.jpg";
import tabBgImg6 from "../assets/images/gallery/1.jpg";

const GalleryData = [
  {
    image: tabImg1,
    bigImage: tabBgImg1,
  },
  {
    image: tabImg2,
    bigImage: tabBgImg2,
  },
  {
    image: tabImg3,
    bigImage: tabBgImg3,
  },
  {
    image: tabImg4,
    bigImage: tabBgImg4,
  },
  {
    image: tabImg5,
    bigImage: tabBgImg5,
  },
  {
    image: tabImg6,
    bigImage: tabBgImg6,
  },
];

class GallerySection extends Component {
  constructor(props) {
    super(props);
    this.state = {
      photoIndex: 0,
      isOpen: false,
    };
  }

  render() {
    const { photoIndex, isOpen } = this.state;

    return (
      <div className="rn-portfolio-area ptb--40 bg_color--1">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="section-title text-center mb--50">
                <h2 className="title">Yaptığımız Çalışmalar</h2>
                <p>
                  Fethiye ve çevresinde gerçekleştirdiğimiz bazı elektrik ve
                  enerji projeleri.
                </p>
              </div>
            </div>
          </div>

          <div className="row">
            {GalleryData.map((item, index) => (
              <div className="col-lg-4 col-md-6 col-12 mb--30" key={index}>
                <div
                  className="portfolio-style--3"
                  onClick={() =>
                    this.setState({ isOpen: true, photoIndex: index })
                  }
                  style={{ cursor: "pointer" }}
                >
                  <div className="thumbnail">
                    <img className="w-100" src={item.image} alt={item.title} />
                  </div>
                  <div className="content text-center">
                    <h4 className="title mt--15">{item.title}</h4>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {isOpen && (
          <Lightbox
            mainSrc={GalleryData[photoIndex].bigImage}
            nextSrc={
              GalleryData[(photoIndex + 1) % GalleryData.length].bigImage
            }
            prevSrc={
              GalleryData[
                (photoIndex + GalleryData.length - 1) % GalleryData.length
              ].bigImage
            }
            onCloseRequest={() => this.setState({ isOpen: false })}
            onMovePrevRequest={() =>
              this.setState({
                photoIndex:
                  (photoIndex + GalleryData.length - 1) % GalleryData.length,
              })
            }
            onMoveNextRequest={() =>
              this.setState({
                photoIndex: (photoIndex + 1) % GalleryData.length,
              })
            }
          />
        )}
      </div>
    );
  }
}

export default GallerySection;
